import { useCallback } from 'react';
import { Appointment } from '@weave/schema-gen-ts/dist/schemas/appointments/v3/model.pb';
import { Template } from '@weave/schema-gen-ts/dist/schemas/messaging/templator/v2/model.pb';
import { AppointmentSelectorModalContentsV2 } from '@frontend/appointment-selector';
import { ModalControlWithKeepState } from '@frontend/integrated-messaging';
import { useModalControl } from '@frontend/design-system';
import { useTemplateMessagingStore } from '../stores/template-selector-store';
import { TemplateSelectorModal } from './template-selector-modal';

type SelectTemplateArgs = {
  appointment?: Appointment;
  template: Template;
};
type ScheduleTemplateModalProps = ModalControlWithKeepState & {
  groupId: string;
  personId: string;
  onSelectTemplate: (args: SelectTemplateArgs) => void;
  onInsert: (selectedTemplate: SelectTemplateArgs) => void;
  onOpenSettings?: () => void;
  settingsOpenDelay?: number;
  appointments?: Appointment[];
  isLoading?: boolean;
};

export const ScheduleTemplateModal = ({
  groupId,
  personId,
  onSelectTemplate,
  show,
  onOpenSettings,
  settingsOpenDelay,
  appointments,
  isLoading,
  onInsert,
  ...modalProps
}: ScheduleTemplateModalProps) => {
  const modalControl = useModalControl();
  const booleanShow = show === 'hidden' ? false : show;
  const { selectedMessageTemplate, setSelectedMessageTemplateType } = useTemplateMessagingStore(
    'selectedMessageTemplate',
    'setSelectedMessageTemplateType'
  );
  const handleScheduleTemplateInsert = useCallback(
    (appointment: Appointment) => {
      if (selectedMessageTemplate) onInsert({ template: selectedMessageTemplate, appointment });
      setSelectedMessageTemplateType();
    },
    [selectedMessageTemplate]
  );

  return (
    <TemplateSelectorModal {...modalControl.modalProps} show={booleanShow}>
      <AppointmentSelectorModalContentsV2
        groupId={groupId}
        personId={personId!}
        onSelect={handleScheduleTemplateInsert}
        onSkip={setSelectedMessageTemplateType}
        onClose={modalProps.onClose}
        onBack={setSelectedMessageTemplateType}
      />
    </TemplateSelectorModal>
  );
};
